import axios from 'axios';
import {load} from 'recaptcha-v3'
import store from '../store'
import {SET_STATE_DATA} from "@/store/actions/se";

const env = [
  // {uiloc: ['localhost'], apiloc: 'http://localhost:8082/duiu', siteKey: ''},
  {uiloc: ['localhost'], apiloc: 'https://api-ecs.duiu.devl-du.aws.fanniemae.com/duiu', siteKey: ''},
  // {uiloc: ['localhost'], apiloc: 'https://api-ecs-alb.duiu.acpt-du.aws.fanniemae.com/duiu', siteKey: ''},


  {uiloc: ['ui-ecs.duiu.devl-du.aws.fanniemae.com'], apiloc: 'https://api-ecs.duiu.devl-du.aws.fanniemae.com/duiu', siteKey: ''},
  {uiloc: ['devl.duiu.du.devl.intgfanniemae.com'], apiloc: 'https://devlapi.duiu.du.devl.intgfanniemae.com/duiu', siteKey: '', external: true},

  {uiloc: ['ui-ecs.duiu.test-du.aws.fanniemae.com'], apiloc: 'https://api-ecs.duiu.test-du.aws.fanniemae.com/duiu', siteKey: ''},
  {uiloc: ['test.duiu.du.test.intgfanniemae.com'], apiloc: 'https://testapi.duiu.du.test.intgfanniemae.com/duiu', siteKey: '', external: true},

  {uiloc: ['ui-ecs-alb.duiu.acpt-du.aws.fanniemae.com'], apiloc: 'https://api-ecs-alb.duiu.acpt-du.aws.fanniemae.com/duiu', siteKey: ''},
  {uiloc: ['ui-01-ecs.duiu.acpt-du.aws.fanniemae.com'], apiloc: 'https://api-01-ecs.duiu.acpt-du.aws.fanniemae.com/duiu', siteKey: ''},
  {uiloc: ['ui-02-ecs.duiu.acpt-du.aws.fanniemae.com'], apiloc: 'https://api-02-ecs.duiu.acpt-du.aws.fanniemae.com/duiu', siteKey: ''},
  {uiloc: ['acpt.duiu.du.acpt.intgfanniemae.com'], apiloc: 'https://acptapi.duiu.du.acpt.intgfanniemae.com/duiu', siteKey: '', external: true},
  {uiloc: ['incomecalculator.acptfanniemae.com'], apiloc: 'https://acptapi.duiu.du.acpt.intgfanniemae.com/duiu', siteKey: '', external: true},

  {uiloc: ['ui-ecs.duiu.acnt-du.aws.fanniemae.com'], apiloc: 'https://api-ecs.duiu.acnt-du.aws.fanniemae.com/duiu', siteKey: ''},

  {uiloc: ['ui-ecs-alb.duiu.prod-du.aws.fanniemae.com'], apiloc: 'https://api-ecs-alb.duiu.prod-du.aws.fanniemae.com/duiu', siteKey: ''},
  {uiloc: ['ui-01-ecs.duiu.prod-du.aws.fanniemae.com'], apiloc: 'https://api-01-ecs.duiu.prod-du.aws.fanniemae.com/duiu', siteKey: ''},
  {uiloc: ['ui-02-ecs.duiu.prod-du.aws.fanniemae.com'], apiloc: 'https://api-02-ecs.duiu.prod-du.aws.fanniemae.com/duiu', siteKey: ''},
  {uiloc: ['prod.duiu.du.prod.fanniemae.com'], apiloc: 'https://prodapi.duiu.du.prod.fanniemae.com/duiu', siteKey: '', external: true},
  {uiloc: ['incomecalculator.fanniemae.com'], apiloc: 'https://prodapi.duiu.du.prod.fanniemae.com/duiu', siteKey: '', external: true}
]


/**
 * Single authoritative Promise that resolves to the reCAPTCHA instance.
 * Assigned once in setEnv() and awaited by the request interceptor.
 *
 * This solves the intermittent short-token problem:
 *   - main.js calls setEnv() without await, so the app mounts and fires
 *     the first API call (conversation) before reCAPTCHA is ready.
 *   - Without this shared promise the interceptor called load() again
 *     independently, creating a race between two concurrent loads.
 *   - Now the interceptor always awaits the SAME initialization chain,
 *     guaranteeing execute() is only called on a fully-loaded instance.
 */
let _recaptchaReady = null   // Promise<ReCaptchaInstance>

const setEnv = async () => {
  axios.defaults.baseURL = "localhost"
  for (let cfg of env) {
    if (hasMatchingUrl(cfg.uiloc)) {
      axios.defaults.baseURL = cfg.apiloc
      await store.commit(SET_STATE_DATA, {key: 'externalMode', value: !!cfg.external})

      // Build the one-and-only init chain and store it at module level so
      // the request interceptor can await it even when a request fires before
      // setEnv() has finished (fire-and-forget call in main.js).
      _recaptchaReady = Promise.resolve()
        .then(() => getRecaptchaKey(cfg))          // fetch key from API if needed
        .then(() => load(cfg.siteKey))             // load reCAPTCHA script once

      await _recaptchaReady
      return
    }
  }
}

const hasMatchingUrl = (matchesArr) => {
  for (let host of matchesArr) {
    if (window.location.hostname.indexOf(host) >= 0) {
      return true
    }
  }
  return false
}

const getCaptchaSiteKey = () => {
  for (let cfg of env) {
    if (hasMatchingUrl(cfg.uiloc)) {
      return getRecaptchaKey(cfg)
    }
  }
  return undefined
}

const getRecaptchaKey = (cfg) => {
  if (cfg.siteKey) {
    return cfg.siteKey
  }

  return axios.get(`${cfg.apiloc}/config/gui`)
    .then( response => {
      cfg.siteKey = response.data?.recaptchaKey
    })
    .catch( ({response}) => {
    })
}

/**
 * Get a reCAPTCHA token, retrying if the response is suspiciously short.
 *
 * A fully-initialised reCAPTCHA v3 token is ~2200+ characters.
 * Tokens shorter than MIN_TOKEN_LENGTH indicate that reCAPTCHA has not yet
 * finished its internal warm-up with Google's servers (even after load()
 * resolves), and will fail server-side validation.
 *
 * Retry with exponential back-off gives the service time to complete
 * its handshake before we give up and let the request proceed with
 * whatever token we have.
 */
const MIN_TOKEN_LENGTH = 1000
const MAX_RETRIES = 3

const getRecaptchaToken = async (recaptcha, action = 'api') => {
  let token
  for (let attempt = 0; attempt < MAX_RETRIES; attempt++) {
    token = await recaptcha.execute(action)
    if (token && token.length >= MIN_TOKEN_LENGTH) {
      return token
    }
    console.warn(
      `[recaptcha] token too short (${token?.length} chars) on attempt ${attempt + 1}/${MAX_RETRIES}, retrying…`
    )
    // Exponential back-off: 500 ms, 1 000 ms, 2 000 ms
    await new Promise(resolve => setTimeout(resolve, 500 * Math.pow(2, attempt)))
  }
  // Return the last token — better to proceed than to block the user forever
  console.warn(`[recaptcha] giving up after ${MAX_RETRIES} attempts, using short token (${token?.length} chars)`)
  return token
}

const saveRequest = (request) => {
    let preparedRequest = request;
    if (request.requestId && request.requestId.length > 0) {
      return axios.put(`request/${request.requestId}`, preparedRequest);
    } else {
      return axios.post('request', preparedRequest);
    }
}

const getRequest = (requestId, amount) => {
  // console.log('getRequest', requestId, amount)
    return axios.get(`request/${requestId}`,
      {
        params: {
          ...(store.state.se.externalMode ? {'amount': amount}: {})
        }
      });
}

const evaluate = (request) => {
  let preparedRequest = request;
  return axios.post('eval', preparedRequest);
}

const getPdfReport = (requestId, amount) => {
  return axios.get(`request/${requestId}/report`, {
    responseType: 'blob',
    headers: {'accept': 'application/pdf'},
    params: {
      ...(store.state.se.externalMode ? {'amount': amount}: {})
    }
  });
}

const createCaseFileAssociation = (caseFileId, requestId, zip, propertyZip, employmentStartDate, incomeAmount) => {
  incomeAmount = incomeAmount ?? null
  employmentStartDate = employmentStartDate ?? null
  let params = {
    'zip': zip
  }
  if (propertyZip) {
    params['property_zip'] = propertyZip
  }
  if (employmentStartDate) {
    params['start_date'] = employmentStartDate
  }
  if (incomeAmount) {
    params['income_amount'] = incomeAmount
  }

  return axios.post(`casefile/${caseFileId}/${requestId}`,
    {
      headers: {'Access-Control-Allow-Origin': '*'}
    },
    {
      params
  });
}

const removeCaseFileAssociation = (caseFileId, requestId) => {
  return axios.delete(`casefile/${caseFileId}/${requestId}`);
}

const getCaseFile = (duCaseFileId) => {
  return axios.get(`casefile/${duCaseFileId}`);
}

const checkConversationId = () => {
  return axios.get(`conversation`);
}

const getConfigGui = () => {
  return axios.get(`/config/gui`);
}

// Given a free-text earnings-line description (e.g. "sick", "holiday pay"), asks the
// API to guess the appropriate income category. Resolves to the response body
// ({categoryType, militaryCategoryType}) on success, or null if the API responded
// with 404 (no match found). Any other error is rethrown so callers can decide how
// to handle it (e.g. ignore network hiccups without caching a negative result).
const getIncomeCategory = (desc) => {
  return axios.get('category', {params: {desc}})
    .then(response => response.data)
    .catch(error => {
      if (error?.response?.status === 404) {
        return null
      }
      throw error
    })
}

axios.interceptors.request.use(async (config) => {
    if (config.url.endsWith('config/gui')) {
      return config;
    }

    // Always await the single initialization promise from setEnv().
    // This serialises all requests behind reCAPTCHA being fully ready,
    // eliminating the race condition that produced short (~550 char) tokens.
    if (!_recaptchaReady) {
      // Fallback: setEnv() was never called or env didn't match — try a fresh load
      _recaptchaReady = Promise.resolve(getCaptchaSiteKey()).then(key => load(key))
    }
    const recaptcha = await _recaptchaReady
    config.headers['x-fnma-recaptcha-token'] = await getRecaptchaToken(recaptcha)

    if (store.state.se.conversationId) {
      config.headers['x-conversation-id'] = store.state.se.conversationId
    }
    return config;
  }, function (error) {
    return Promise.reject(error);
  });


axios.interceptors.response.use((response) => {
    return response;
  }, (error) => {
    if (error.response.status === 403) {
      router.push('/forbidden-error')
    }
    return Promise.reject(error);
  })

export default { setEnv, saveRequest, getRequest, evaluate, getPdfReport, createCaseFileAssociation,
  removeCaseFileAssociation, getCaseFile, checkConversationId, getRecaptchaKey, getConfigGui, getIncomeCategory }
